<template>
  <div class="empty-content">
    <i class="material-icons">
      search
    </i>
    <div class="empty-content-text" v-html="message" />
  </div>
</template>

<script>
export default {
  name: 'NotResultDummy',
  props: {
    message: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.empty-content{
  text-align: center;
  padding: 34px 0 72px;
  .material-icons{
    font-size: 140px;
    color: $grey-ec;
  }
  .empty-content-text{
    font-size: 20px;
    line-height: 1.6;
    color: $grey-50;
    padding: 24px 0 68px;
  }
}
</style>
